module.exports = __webpack_public_path__ + "static/media/Material-Icons.4f495c90.woff";